import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import React from 'react';
import { Experience } from '../../../API';
import TechnicalSkill from '../../../models/technical-skills';
import { User } from '../../Authentication';
import ExperienceCardContent from '../ExperienceCardContent';
import PersonalInfoCardContent from '../PersonalInfoCardContent';
import SkillsContentCard from '../SkillsContentCard';

export type BasicProfile = {
  firstName: string;
  experience?: Experience;
  skills?: TechnicalSkill[];
};

// function ProfileSkillArea({
//   skillArea, level, mainSkills, secondarySkills, showFrequency = false,
// }: {
//   skillArea: SkillArea,
//   level?: Level | '',
//   mainSkills?: TechnicalSkill[],
//   secondarySkills?: TechnicalSkill[],
//   showFrequency?: boolean
// }) {
//   const classes = useStyles({ skillArea });
//   if (!level) return null;
//   return (
//     <>
//       <Divider />
//       <CardContent className={classes.profileContentSkills}>
//         <Typography variant="h5" className={classes.skillAreaTitle}>
//           {SKILL_AREA_ICONS[skillArea]}
//           {SKILL_AREA_HUMAN_NAMES[skillArea]}
//           <LevelDisplay level={level} />
//         </Typography>
//         {Boolean(mainSkills?.length) && (
//           <Box className={classes.skillChips}>
//             {makeSkillChips(mainSkills, { showFrequency })}
//           </Box>
//         )}
//         {Boolean(secondarySkills?.length) && (
//           <Box className={classes.skillChips}>
//             {makeSkillChips(secondarySkills, { small: true, showFrequency })}
//           </Box>
//         )}
//       </CardContent>
//     </>
//   );
// }

export default function BasicProfileDisplay({
  profile,
  user,
  // showSkillsFrequency,
}: {
  profile: BasicProfile,
  user?: User,
  // showSkillsFrequency?: boolean,
}) {
  const personalInfo = {
    picture: user?.picture,
    name: user?.name || profile.firstName || 'Your name',
    github: user?.github,
    email: user?.email,
  };
  return (
    <div>
      <Card>
        <PersonalInfoCardContent info={personalInfo} />
        {profile.experience && (
          <>
            <Divider />
            <ExperienceCardContent experience={profile.experience} />
          </>
        )}
        <Divider />
        <SkillsContentCard skills={profile.skills || []} />
      </Card>
    </div>
  );
}
